import { getCurrentSystem } from '@umu/ukit-lang';

// 导入所有模板文件
import templateDefault from '../../../images/caetTemplate/template-default.svg';
import templateCN from '../../../images/caetTemplate/template-cn.svg';
import templateCo from '../../../images/caetTemplate/template-co.svg';

// 模板映射表 为后续多模版和多系统支持进行预留
const TEMPLATE_MAP: Record<string, string> = {
    default: templateDefault,
    en: templateDefault, // 美国站点使用默认模板
    cn: templateCN,
    jp: templateCo,
};

// 缓存模板内容，key 为 targetSystem，value 为 Promise<string>
const templateCache = new Map<string, Promise<string>>();

/**
 * 获取证书模板内容
 * 支持不同系统加载不同模板文件
 * 当 targetSystem 不变时，直接返回缓存内容
 */
export const getCertificateTemplate = async (system?: string): Promise<string> => {
    const targetSystem = (system || getCurrentSystem()).toLowerCase();

    // 检查缓存，如果存在直接返回
    if (templateCache.has(targetSystem)) {
        return templateCache.get(targetSystem)!;
    }

    // 创建新的 Promise 并缓存
    const templatePromise = (async () => {
        try {
            // 根据系统从模板映射表中获取模板
            const template = TEMPLATE_MAP[targetSystem] || TEMPLATE_MAP['default'];
            const response = await fetch(template);
            return response?.text?.() || '';
        } catch (_error) {
            const fallbackSvg = `
                <svg width="800" height="600" xmlns="http://www.w3.org/2000/svg">
                </svg>
            `;

            return fallbackSvg;
        }
    })();

    // 将 Promise 存入缓存
    templateCache.set(targetSystem, templatePromise);

    return templatePromise;
};
